import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ContactForm = () => {
  const [form, setForm] = useState({
    naam: '',
    email: '',
    telefoon: '',
    postcode: '',
    panelen: '',
    voorkeur: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!form?.naam?.trim()) e.naam = 'Naam is verplicht';
    if (!form?.email?.trim() || !/\S+@\S+\.\S+/?.test(form?.email)) e.email = 'Geldig e-mailadres verplicht';
    if (!form?.telefoon?.trim()) e.telefoon = 'Telefoonnummer is verplicht';
    if (!form?.postcode?.trim()) e.postcode = 'Postcode is verplicht';
    return e;
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (errors?.[field]) setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    const e2 = validate();
    if (Object.keys(e2)?.length > 0) {
      setErrors(e2);
      return;
    }
    setSubmitted(true);
  };

  return (
    <section id="formulier" className="py-16 lg:py-24 bg-primary">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-white leading-tight mb-4">
            Klaar om je eigen stroom te bewaren?
          </h2>
          <p className="font-body text-white/80 text-lg">
            Plan een gratis, vrijblijvend adviesgesprek. Geen verkooppraatje — gewoon eerlijk advies.
          </p>
        </div>

        {!submitted ? (
          <div className="bg-white rounded-2xl shadow-elevation-3 p-8 lg:p-10">
            <form onSubmit={handleSubmit} noValidate className="space-y-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {/* Naam */}
                <div>
                  <label className="block text-sm font-heading font-semibold text-foreground mb-1.5">
                    Naam <span className="text-destructive">*</span>
                  </label>
                  <input
                    type="text"
                    value={form?.naam}
                    onChange={(e) => handleChange('naam', e?.target?.value)}
                    placeholder="Jan de Vries"
                    className={`w-full px-4 py-3 text-sm border rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 transition-colors ${errors?.naam ? 'border-destructive' : 'border-border'}`}
                  />
                  {errors?.naam && <p className="text-xs text-destructive mt-1">{errors?.naam}</p>}
                </div>

                {/* Email */}
                <div>
                  <label className="block text-sm font-heading font-semibold text-foreground mb-1.5">
                    E-mail <span className="text-destructive">*</span>
                  </label>
                  <input
                    type="email"
                    value={form?.email}
                    onChange={(e) => handleChange('email', e?.target?.value)}
                    placeholder="jan@email.nl"
                    className={`w-full px-4 py-3 text-sm border rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 transition-colors ${errors?.email ? 'border-destructive' : 'border-border'}`}
                  />
                  {errors?.email && <p className="text-xs text-destructive mt-1">{errors?.email}</p>}
                </div>

                {/* Telefoon */}
                <div>
                  <label className="block text-sm font-heading font-semibold text-foreground mb-1.5">
                    Telefoon <span className="text-destructive">*</span>
                  </label>
                  <input
                    type="tel"
                    value={form?.telefoon}
                    onChange={(e) => handleChange('telefoon', e?.target?.value)}
                    placeholder="06 12345678"
                    className={`w-full px-4 py-3 text-sm border rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 transition-colors ${errors?.telefoon ? 'border-destructive' : 'border-border'}`}
                  />
                  {errors?.telefoon && <p className="text-xs text-destructive mt-1">{errors?.telefoon}</p>}
                </div>

                {/* Postcode */}
                <div>
                  <label className="block text-sm font-heading font-semibold text-foreground mb-1.5">
                    Postcode + huisnummer <span className="text-destructive">*</span>
                  </label>
                  <input
                    type="text"
                    value={form?.postcode}
                    onChange={(e) => handleChange('postcode', e?.target?.value)}
                    placeholder="1234 AB 12"
                    className={`w-full px-4 py-3 text-sm border rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 transition-colors ${errors?.postcode ? 'border-destructive' : 'border-border'}`}
                  />
                  {errors?.postcode && <p className="text-xs text-destructive mt-1">{errors?.postcode}</p>}
                </div>
              </div>

              {/* Zonnepanelen */}
              <div>
                <label className="block text-sm font-heading font-semibold text-foreground mb-2">
                  Heb je zonnepanelen?
                </label>
                <div className="flex gap-3">
                  {['Ja', 'Nee', 'Weet ik niet']?.map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      onClick={() => handleChange('panelen', opt)}
                      className={`flex-1 py-2.5 text-sm font-heading font-semibold rounded-md border transition-colors ${
                        form?.panelen === opt
                          ? 'bg-primary text-primary-foreground border-primary'
                          : 'bg-white text-foreground border-border hover:border-primary/50'
                      }`}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
              </div>

              {/* Voorkeur batterij */}
              <div>
                <label className="block text-sm font-heading font-semibold text-foreground mb-2">
                  Voorkeur batterij
                </label>
                <div className="flex gap-3 flex-wrap">
                  {['Grafeen', 'Lithium', 'Weet ik nog niet']?.map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      onClick={() => handleChange('voorkeur', opt)}
                      className={`px-4 py-2.5 text-sm font-heading font-semibold rounded-md border transition-colors ${
                        form?.voorkeur === opt
                          ? 'bg-primary text-primary-foreground border-primary'
                          : 'bg-white text-foreground border-border hover:border-primary/50'
                      }`}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
              </div>

              {/* Submit */}
              <div className="pt-2">
                <button
                  type="submit"
                  className="w-full py-4 bg-primary text-primary-foreground font-heading font-bold text-base rounded-md hover:bg-primary/90 transition-all duration-200 shadow-elevation-2 hover:shadow-elevation-3 hover:-translate-y-0.5 flex items-center justify-center space-x-2"
                >
                  <span>Plan mijn gratis adviesgesprek</span>
                  <Icon name="ArrowRight" size={18} />
                </button>
              </div>

              {/* Expectation management */}
              <div className="flex items-center justify-center space-x-2 text-muted-foreground">
                <Icon name="Clock" size={14} />
                <p className="text-xs font-caption text-center">
                  Binnen één werkdag persoonlijk contact. Vrijblijvend, geen verkooppraatje.
                </p>
              </div>

              {/* Privacy */}
              <p className="text-xs font-caption text-muted-foreground text-center">
                Door dit formulier in te sturen ga je akkoord met onze{' '}
                <a href="/privacy" className="text-primary hover:underline">privacyverklaring</a>.
                Je gegevens worden uitsluitend gebruikt voor het adviesgesprek (AVG-compliant).
              </p>
            </form>
          </div>
        ) : (
          <div className="bg-white rounded-2xl shadow-elevation-3 p-12 text-center">
            <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-5">
              <Icon name="CheckCircle" size={32} className="text-success" />
            </div>
            <h3 className="text-2xl font-heading font-bold text-foreground mb-3">Aanvraag ontvangen!</h3>
            <p className="font-body text-muted-foreground leading-relaxed max-w-md mx-auto">
              Bedankt, <strong>{form?.naam}</strong>. We nemen binnen één werkdag contact met je op voor het gratis adviesgesprek.
            </p>
            <div className="mt-6 flex items-center justify-center space-x-2 text-muted-foreground">
              <Icon name="Mail" size={16} />
              <p className="text-sm font-body">Bevestiging verstuurd naar {form?.email}</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default ContactForm;
